'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import { requiresOnboarding, resolvePostAuthRedirect } from '@/lib/auth-routing';

export function OnboardingGuard({ children }: { children: React.ReactNode }) {
  const { user, organizations, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate('/login?redirect=/onboarding', { replace: true });
      return;
    }

    if (!user.emailVerified || user.status === 'pending_verification') {
      navigate('/verify-email/pending', { replace: true });
      return;
    }

    if (user.isStaff) {
      navigate('/admin', { replace: true });
      return;
    }

    if (!requiresOnboarding(user, organizations)) {
      navigate(resolvePostAuthRedirect(user, organizations), { replace: true });
    }
  }, [loading, user, organizations, navigate]);

  if (loading || !user || !requiresOnboarding(user, organizations)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-brand border-t-transparent" />
      </div>
    );
  }

  return <>{children}</>;
}
